<div
  fxLayout="row"
  fxLayout.xs="column"
  style="height: 778px !important; min-height: 500px"
>
  <as-split direction="horizontal">
    <as-split-area size="30">
      <div fxLayout="column" fxLayout.xs="column">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h6>{{ siteId }}</h6>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row">
            <mat-tree
              #tree
              [dataSource]="dataSource"
              [(treeControl)]="treeControl"
            >
              <mat-tree-node
                [id]="node.title"
                class="site-mat-tree-node tree-node-divider"
                *matTreeNodeDef="let node"
                matTreeNodeToggle
                matTreeNodePadding
                (click)="featureLeafItemSelectionToggle(node)"
                [ngClass]="{ 'background-highlight': activeNode === node }"
              >
                <button
                  type="button"
                  (click)="$event.preventDefault()"
                  mat-icon-button
                  disabled
                ></button>
                <mat-label class="tree-nodeClass">{{ node.title }} </mat-label>
              </mat-tree-node>

              <mat-tree-node
                [id]="node.title"
                class="site-mat-tree-node tree-node-divider"
                *matTreeNodeDef="let node; when: hasChild"
                matTreeNodePadding
                (click)="featureItemSelectionToggle(node)"
                [ngClass]="{ 'background-highlight': activeNode === node }"
              >
                <button
                  type="button"
                  (click)="$event.preventDefault()"
                  mat-icon-button
                  matTreeNodeToggle
                  [attr.aria-label]="'toggle ' + node.filename"
                >
                  <mat-icon
                    *ngIf="treeControl.isExpanded(node)"
                    fontIcon="Bosch-Ic-arrow-expand-down"
                  ></mat-icon>
                  <mat-icon
                    *ngIf="!treeControl.isExpanded(node)"
                    fontIcon="Bosch-Ic-arrow-expand-right"
                  ></mat-icon>
                </button>
                <mat-icon
                  class="marginRight"
                  fontIcon="{{
                    treeControl.isExpanded(node)
                      ? 'bosch-ic-folder-open'
                      : 'bosch-ic-folder'
                  }}"
                ></mat-icon>
                <mat-label class="tree-nodeClass">{{ node.title }}</mat-label>
              </mat-tree-node>
            </mat-tree>
          </div>
        </mat-expansion-panel>
      </div>
    </as-split-area>

    <as-split-area size="70">
      <div
        fxLayout="row"
        fxLayout.xs="column"
        style="align-items: center !important; background: #f5f5f5 !important"
        class="site-layout"
      >
        <div class="col-md-5">
          <h6>
            Specific Energy for
            <span class="nodetitle" *ngIf="this.currentNode.nodeData">{{
              this.currentNode.nodeData.title
            }}</span>
          </h6>
        </div>

        <div class="col-md-5 pull-right">
          <span class="text">Select Date Range:</span>

          <input
            class="datepicker dateStyle"
            type="text"
            ngxDaterangepickerMd
            [(ngModel)]="dateRange"
            [showCustomRangeLabel]="true"
            [alwaysShowCalendars]="true"
            [ranges]="ranges"
            [linkedCalendars]="true"
            [showClearButton]="true"
            (ngModelChange)="onChangeDateRange()"
            [locale]="{ format: 'YYYY-MM-DD' }"
          />
        </div>
        <div class="col-md-2 pull-right">
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            class="text marginbtn"
          >
            Filter
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="add icon"
                class="bosch-ic-filter"
                style="width: max-content"
              >
              </mat-icon>
            </span>
          </button>
          <mat-menu #menu="matMenu">
            <div>
              <mat-label class="menuheader">View</mat-label>
              <button
                class="pull-right clearStyle"
                (click)="onClearButtonClicked()"
              >
                <span>Clear</span>
              </button>
            </div>
            <mat-radio-group
              name="radioOpt1"
              [(ngModel)]="useShiftwise"
              [ngModelOptions]="{ standalone: true }"
              (change)="onShiftwiseChanged($event)"
            >
              <button mat-menu-item class="text">
                <mat-radio-button value="no"></mat-radio-button>
                <span>Without Shiftwise</span>
              </button>
              <button
                mat-menu-item
                class="text"
                (click)="onShiftwiseChanged(true)"
              >
                <mat-radio-button value="yes"></mat-radio-button>
                <span>Shiftwise</span>
              </button>
            </mat-radio-group>
            <mat-divider></mat-divider>

            <div>
              <mat-label class="menuheader">Time Range</mat-label>
            </div>

            <mat-radio-group
              name="radioOpt3"
              [(ngModel)]="currentTimeRange"
              [ngModelOptions]="{ standalone: true }"
              (change)="onTimeRangeChanged($event)"
            >
              <button mat-menu-item class="text">
                <mat-radio-button value="daily"></mat-radio-button>
                <span>Daily</span>
              </button>
              <button mat-menu-item class="text" *ngIf="isAdmin === true">
                <mat-radio-button value="weekly"></mat-radio-button>
                <span>Weekly</span>
              </button>
              <button mat-menu-item class="text" *ngIf="isAdmin === true">
                <mat-radio-button value="monthly"></mat-radio-button>
                <span>Monthly</span>
              </button>
              <button mat-menu-item class="text" *ngIf="isAdmin === true">
                <mat-radio-button value="yearly"></mat-radio-button>
                <span>Yearly</span>
              </button>
            </mat-radio-group>
            <mat-divider></mat-divider>

            <div>
              <mat-label class="menuheader">Product</mat-label>
            </div>
            <mat-radio-group
              name="radioOpt2"
              [(ngModel)]="selectedProducts"
              [ngModelOptions]="{ standalone: true }"
              (change)="productSelectclick($event)"
            >
              <button mat-menu-item class="text">
                <mat-radio-button value="all" name="all"></mat-radio-button>
                <span>All</span>
              </button>
              <button
                mat-menu-item
                *ngFor="let product of productsOfSite"
                class="text"
              >
                <mat-radio-button value="product.rId" name="product.rId">
                </mat-radio-button>
                <span>{{ product.name }}</span>
              </button>
            </mat-radio-group>
          </mat-menu>
        </div>
      </div>

      <div
        fxLayout="row"
        fxLayout.xs="column"
        style="align-items: center !important"
        class="site-layout"
        *ngIf="hasChart"
      >
        <div
          class="col-xs-8 col-sm-8 col-md-8 col-lg-8"
          style="line-height: 120px"
        >
          <button
            (click)="onDisplaysClick('all')"
            class="btn mat-raised-button marginRight"
          >
            All
          </button>
          <button
            (click)="onDisplaysClick('energy')"
            class="btn mat-raised-button marginRight"
          >
            Energy
          </button>
          <button
            (click)="onDisplaysClick('production')"
            class="btn mat-raised-button marginRight"
          >
            Production
          </button>

          <button
            (click)="onDisplaysClick('target')"
            class="btn mat-raised-button marginRight"
          >
            Target
          </button>
        </div>
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <div class="pull-right row" *ngIf="currentSuccessMessage !== ''">
            <div
              class="col-xs-5 col-sm-5 col-md-5 col-lg-5"
              [chart]="rateChart"
            ></div>
            <div
              class="col-xs-7 col-sm-7 col-md-7 col-lg-7"
              style="margin-top: 1em"
            >
              <span class="success-rate">{{ currentSuccessPercent }}%</span>
              <br />
              {{ currentSuccessMessage }}
            </div>
          </div>
        </div>
      </div>

      <div
        id="chartContainer"
        fxLayout="row"
        fxLayout.xs="column"
        style="width: 98%"
        *ngIf="hasChart"
      >
        <div [chart]="columnchart" style="width: 100%"></div>
      </div>

      <div
        id="chartContainer"
        fxLayout="row"
        fxLayout.xs="column"
        style="width: 100%"
        *ngIf="!hasChart"
      >
        <div
          class="col-xs-8 col-sm-8 col-md-8 col-lg-8"
          style="line-height: 300px"
        >
          No data to display!
        </div>
      </div>
      <mat-action-row class="expansion-footer">
        <mat-label> &nbsp; {{ totalEnergy }}</mat-label>
      </mat-action-row>
    </as-split-area>
  </as-split>
</div>
